import { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./AddForecastSpecification.scss";
import { Stepper } from "../../../Stepper/Stepper";
import { useDispatch, useSelector } from "react-redux";
import {
  SaveBtn,
  CancelBtn,
  addForecastSpecificationEndYear,
  addForecastSpecificationStartYear,
  addForecastSpecificationPercentValue,
  addForecastSpecificationDataTypeOptions,
  addForecastSpecificationForecastDesc,
  addForecastSpecificationForecastName,
  addForecastSpecificationHeader,
  addForecastSpecificationDataType,
  addForecastSpecificationDataSelectionRequired,
  addForecastSpecificationStartYearLessThanFEY,
  addForecastSpecificationStartYearGreaterThanMRY,
  addForecastSpecificationStartYearRequired,
  addForecastSpecificationEndYearRequired,
  addForecastSpecificationPercentValueRequired,
  addForecastSpecificationDataTypeRequired,
  addForecastSpecificationForecastNameRequired,
  addForecastSpecificationEndYearGreaterThanMRY,
  addForecastSpecificationEndYearLessThanFEY,
  addForecastSpecificationEndYearLessThanStartYear,
  addForecastSpecificationStartYearGreaterThanEndYear,
  targetPercentageError,
  forecastDescriptionTooltip,
  forecastPercentageTooltip,
  forecastStartYearTooltip,
  forecastEndYeartooltip,
  forecastNameTooltip,
  forecastDataTypeTooltip,
  decimalNumberRegExpForecast,
  DataSelection,
  addForecastNameRequiredMaxLength,
  forecastNameRegExp,
  maxLength100,
  forecastDescRegExp,
  addForecastDescMaxLength,
  maxLength2000,
  wafErrorMessage,
  commonError
} from "../../../../util/constants";
import { Input } from "../../../CommonUIComponents/Input/Input";
import { TextArea } from "../../../CommonUIComponents/TextArea/TextArea";
import { Button } from "../../../CommonUIComponents/Button/Button";
import { EmissionIcon, AreaSeacrhIcon } from "../../../../icons";
import { routes } from "../../../../routes/routes.constatns";
import { Select } from "../../../CommonUIComponents/Select/Select";
import { getHierarchyLevelData } from "../../../../store/services/engagement.service";
import {
  getForecastByGroupId,
  updateForecastSpecification,
  saveForecastSpecification,
  allSaveForecastSpecification,
  checkName,
  allUpdateForecast,
} from "../../../../store/services/forecast.service";
import { setHierarchialData, setselectedUIAllFilters } from "../../../../store/slices/forecastSlice";
import { MotifErrorMessage } from "../../../../assets/lib/motif";
import { LoadingIndicatorEmbed } from "../../../CommonUIComponents/LoadingIndicator/LoadingIndicatorEmbed";
import { Tooltip } from "../../../CommonUIComponents/Tooltip/Tooltip";
import { M2FilterModal } from "./M2FilterModal";
import { processEmissionData, handleAllpayload, processCustomData, processOrgData, processRegionData } from "./ForecastUtils";
import { setWafErrorFlag } from "../../../../store/slices/projectSlice";

export function AddForecastSpecification() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const dispatch = useDispatch();
  const steps = useSelector((state) => state.stepper.steps);
  const engagement = useSelector((state) => state.engagement.engagement);
  const stepIndex = useSelector((state) => state.engagement.stepIndex);
  const currentStep = useSelector((state) => state.engagement.currentStep);
  const user = useSelector((state) => state.user.user);
  const selectedUIAllFilters = useSelector(
      (state) => state.forecast.selectedUIAllFilters
    );
  const wafErrorFlag = useSelector((state) => state.project.wafErrorFlag);  
  const [isDataSaveInProgress, setIsDataSaveInProgress] = useState(false);
  const [forecastName, setForecastName] = useState("");
  const [forecastErrorName, setForecastErrorName] = useState("");
  const [forecastDescription, setForecastDescription] = useState("");
  const [percentageValue, setPercentage] = useState();
  const [forecastErrorPercent, setForecastErrorPercent] = useState("");
  const [startYear, setStartYear] = useState();
  const [forecastErrorStartYear, setForecastErrorStartYear] = useState("");
  const [endYear, setEndYear] = useState();
  const [forecastErrorEndYear, setForecastErrorEndYear] = useState("");
  const [dataTypefield, setDatatype] = useState();
  const [dataTypeError, setDataTypeError] = useState("");
  const [wafErrorMessageState, setWafErrorMessageState] = useState("");

  const [emissionModalData, setEmissionModalData] = useState([]);
  const [geoSpecModalData, setGeoSpecModalData] = useState([]);
  const [orgSpecModalData, setOrgSpecModalData] = useState([]);
  const [customModalData, setCustomModalData] = useState([]);

  const [forecastErrorDataSelectionModal, setForecastErrorDataSelectionModal] = useState("");
  const [forecastData, setForecastData] = useState({});
 
  const [dropdownloader, setDropdownLoader] = useState(false);
  const [isDisableSave, setIsDisableSave] = useState(false);
  const decimalNumberRegExp = decimalNumberRegExpForecast;
  const lastCheckedForecastName = useRef("");

  const [openHierarchyModal, setOpenHierarchyModal] = useState(false);
  const [hierarchialData, setHierarchyData] = useState([]);
  const [forecastErrorDesc, setForecastErrorDesc] = useState("");

    useEffect(() => {
      if (wafErrorFlag) {
        setWafErrorMessageState(wafErrorMessage);
      }
    }, [wafErrorFlag]);

  function handleCancelClick() {
    navigate(`/${routes.createNewEngagement}/${routes.addforecast}`, {
      state: {
        engagementId: engagement.id,
      },
      gestureEnabled: false,
    });
  }

  function validateForm() {
    let isValid = true;
    if (!forecastName) {
      setForecastErrorName(addForecastSpecificationForecastNameRequired);
      isValid = false;
    }

    if (!percentageValue) {
      setForecastErrorPercent(addForecastSpecificationPercentValueRequired);
      isValid = false;
    }

    if (
      percentageValue &&
      (!decimalNumberRegExp.test(percentageValue) ||
        percentageValue > 100 ||
        percentageValue < -100)
    ) {
      setForecastErrorPercent(targetPercentageError);
      isValid = false;
    }

    if (!dataTypefield) {
      setDataTypeError(addForecastSpecificationDataTypeRequired);
      isValid = false;
    }

    if (!startYear) {
      setForecastErrorStartYear(addForecastSpecificationStartYearRequired);
      isValid = false;
    }

    if (startYear && parseFloat(startYear) <= engagement.mostRecentYear) {
      setForecastErrorStartYear(
        addForecastSpecificationStartYearGreaterThanMRY
      );
      isValid = false;
    }

    if (startYear && parseFloat(startYear) > engagement?.foreCastEndYear) {
      setForecastErrorStartYear(addForecastSpecificationStartYearLessThanFEY);
      isValid = false;
    }

    if (startYear && endYear && parseFloat(startYear) > parseFloat(endYear)) {
      setForecastErrorStartYear(
        addForecastSpecificationStartYearGreaterThanEndYear
      );
      isValid = false;
    }

    if (!endYear) {
      setForecastErrorEndYear(addForecastSpecificationEndYearRequired);
      isValid = false;
    }

    if (endYear && parseFloat(endYear) <= engagement.mostRecentYear) {
      setForecastErrorEndYear(addForecastSpecificationEndYearGreaterThanMRY);
      isValid = false;
    }

    if (endYear && parseFloat(endYear) > engagement?.foreCastEndYear) {
      setForecastErrorEndYear(addForecastSpecificationEndYearLessThanFEY);
      isValid = false;
    }

    if (endYear && startYear && parseFloat(endYear) < parseFloat(startYear)) {
      setForecastErrorEndYear(addForecastSpecificationEndYearLessThanStartYear);
      isValid = false;
    }

    if (!selectedUIAllFilters || !Object.entries(selectedUIAllFilters)?.length > 0) {
      setForecastErrorDataSelectionModal(addForecastSpecificationDataSelectionRequired);
      isValid = false;
    } else {
      if (orgSpecModalData?.entity_level1?.length === 0) {
        setForecastErrorDataSelectionModal(addForecastSpecificationDataSelectionRequired);
        isValid = false;
      }
    }

    return isValid;
  }

  function checkIsDisabled (){
    if(!isDisableSave){
      if(isDataSaveInProgress || forecastName == "" || forecastErrorDesc || forecastErrorName !== "" || percentageValue == undefined || startYear == undefined || endYear == undefined || forecastErrorEndYear !== "" || forecastErrorStartYear !== "" || forecastErrorPercent !== "" || forecastErrorDataSelectionModal != "" || !selectedUIAllFilters || !Object.entries(selectedUIAllFilters)?.length > 0){
        return true;
      } else {
        return false;
      }
    } else{
      if(isDataSaveInProgress || forecastName == "" || forecastErrorDesc || forecastErrorName !== "" || percentageValue == undefined || startYear == undefined || endYear == undefined || forecastErrorEndYear !== "" || forecastErrorStartYear !== "" || forecastErrorPercent !== "" || forecastErrorDataSelectionModal != "" || !selectedUIAllFilters || !Object.entries(selectedUIAllFilters)?.length > 0){
        return true;
      } else {
        return false;
      }
    }
  }
  async function findSmallest(arrays) {
    let smallest = arrays[0];
    let minlength = arrays[0]?.length;
    arrays.forEach((array) => {
      if (array?.length < minlength) {
        smallest = array;
        minlength = array?.length;
      }
    });
    let finalArray = Array.from(new Set(smallest?.map(JSON.stringify))).map(
      JSON.parse
    );
    if (emissionModalData.selectAll === "subCategory1") {
      finalArray.forEach((record) => {
        record.category_level1 = "All";
        record.category_level2 = "All";
        record.category_level3 = "All";
      });
    } else if (emissionModalData?.selectAll === "subCategory2") {
      finalArray.forEach((record) => {
        record.category_level2 = "All";
        record.category_level3 = "All";
      });
    } else if (emissionModalData?.selectAll === "subCategory3") {
      finalArray.forEach((record) => {
        record.category_level3 = "All";
      });
    }
    if (geoSpecModalData?.selectAll === "regionLevel1") {
      finalArray.forEach((record) => {
        record.region_level1 = "All";
        record.region_level2 = "All";
        record.region_level3 = "All";
      });
    } else if (geoSpecModalData?.selectAll === "regionLevel2") {
      finalArray.forEach((record) => {
        record.region_level2 = "All";
        record.region_level3 = "All";
      });
    } else if (geoSpecModalData?.selectAll === "regionLevel3") {
      finalArray.forEach((record) => {
        record.region_level3 = "All";
      });
    }
    if (orgSpecModalData?.selectAll === "orgLevel1") {
      finalArray.forEach((record) => {
        record.entity_level1 = "All";
        record.entity_level2 = "All";
        record.entity_level3 = "All";
        record.entity_level4 = "All";
      });
    } else if (orgSpecModalData?.selectAll === "orgLevel2") {
      finalArray.forEach((record) => {
        record.entity_level2 = "All";
        record.entity_level3 = "All";
        record.entity_level4 = "All";
      });
    } else if (orgSpecModalData?.selectAll === "orgLevel3") {
      finalArray.forEach((record) => {
        record.region_level3 = "All";
        record.entity_level4 = "All";
      });
    } else if (orgSpecModalData?.selectAll === "orgLevel4") {
      finalArray.forEach((record) => {
        record.entity_level4 = "All";
      });
    }
    if (customModalData?.selectAll === "customLevel1") {
      finalArray.forEach((record) => {
        record.custom_specification1 = "All";
        record.custom_specification2 = "All";
        record.custom_specification3 = "All";
      });
    } else if (customModalData?.selectAll === "customLevel2") {
      finalArray.forEach((record) => {
        record.custom_specification2 = "All";
        record.custom_specification3 = "All";
      });
    } else if (customModalData?.selectAll === "customLevel3") {
      finalArray.forEach((record) => {
        record.custom_specification3 = "All";
      });
    }
    finalArray = Array.from(new Set(finalArray.map(JSON.stringify))).map(
      JSON.parse
    );
    return finalArray;
  }
  async function applyChanges() {
    dispatch(setWafErrorFlag(false));
    let isSubmit = false;
    if (!validateForm()) return;
    setIsDataSaveInProgress(true);
    let allpayload = [];
    let finalUniquerecords = [];
    if (customModalData?.allPayload?.length > 0) {
      let arrays = [
        geoSpecModalData.allPayload,
        orgSpecModalData.allPayload,
        customModalData.allPayload,
      ];
      let finalArray = await findSmallest(arrays);
      finalUniquerecords = finalArray;
    } else {
      let arrays = [geoSpecModalData.allPayload, orgSpecModalData.allPayload];
      let finalArray = await findSmallest(arrays);
      finalArray.forEach((record) => {
        record.custom_specification1 = "All";
        record.custom_specification2 = "All";
        record.custom_specification3 = "All";
      });
      finalUniquerecords = finalArray;
    }
    
    try {
      if (forecastData?.id) {
        finalUniquerecords.forEach((record) => {
          let request = {
            engagementID: engagement.id,
            clientname: engagement.clientName,
            name: forecastName,
            description: forecastDescription,
            region_level1: record.region_level1,
            region_level2: record.region_level2,
            region_level3: record.region_level3,
            entity_level1: record.entity_level1,
            entity_level2: record.entity_level2,
            entity_level3: record.entity_level3,
            entity_asset: record.entity_level4,
            scope: record.scope,
            category_level1: record.category_level1,
            category_level2: record.category_level2,
            category_level3: record.category_level3,
            custom_specification1: record.custom_specification1,
            custom_specification2: record.custom_specification2,
            custom_specification3: record.custom_specification3,
            data_type: dataTypefield,
            forecast_percentage: percentageValue,
            startYear: parseFloat(startYear),
            endYear: parseFloat(endYear),
            batchId: forecastData?.batchId ?? 0,
            batchGroupID: forecastData?.batchGroupID ?? 0,
            statusFlag: forecastData?.statusFlag ?? "",
            aD_Key: forecastData?.aD_Key ?? "",
            activeFlag: forecastData?.activeFlag ?? 1,
            id: forecastData?.batchGroupID ?? 0,
            modifiedby: forecastData?.modifiedby ?? user.username,
            modifieddate: forecastData?.modifieddate ?? new Date(),
            forecast_Status: "",
            forecastEndYear: engagement?.foreCastEndYear,
            record_status: "",
            forecastUIInputKey: "",
            isValidated: "Y",
          };
          allpayload.push(request);
        });
        const response = await allUpdateForecast({ allpayload });
        if(response && response.data && response.data.length > 0) {
          isSubmit = true;
        }
      } else {
        finalUniquerecords.forEach((record) => {
          let request = {
            engagementID: engagement.id,
            clientname: engagement.clientName,
            name: forecastName,
            description: forecastDescription,
            region_level1: record.region_level1,
            region_level2: record.region_level2,
            region_level3: record.region_level3,
            entity_level1: record.entity_level1,
            entity_level2: record.entity_level2,
            entity_level3: record.entity_level3,
            entity_asset: record.entity_level4,
            scope: record.scope,
            category_level1: record.category_level1,
            category_level2: record.category_level2,
            category_level3: record.category_level3,
            custom_specification1: record.custom_specification1,
            custom_specification2: record.custom_specification2,
            custom_specification3: record.custom_specification3,
            data_type: dataTypefield,
            forecast_percentage: percentageValue,
            startYear: parseFloat(startYear),
            endYear: parseFloat(endYear),
            createddate: forecastData?.createddate ?? new Date(),
            createdby: forecastData?.createdby ?? user.username,
            batchId: forecastData?.batchId ?? 0,
            batchGroupID: forecastData?.batchGroupID ?? 0,
            statusFlag: forecastData?.statusFlag ?? "",
            aD_Key: forecastData?.aD_Key ?? "",
            activeFlag: forecastData?.activeFlag ?? 1,
            id: forecastData?.batchGroupID ?? 0,
            forecast_Status: "",
            forecastEndYear: engagement?.foreCastEndYear,
            record_status: "",
            forecastUIInputKey: "",
            isValidated: "Y",
          };
          allpayload.push(request);
        });
        const response = await allSaveForecastSpecification({ allpayload });
        if(response && response.data && response.data.length > 0) {
          isSubmit = true;
        }
      }
    } catch (e) {
      isSubmit = false;
      console.error(e);
    }

    let payload = {
      engagementId: engagement.id,
      engagementCode: engagement.engagementCode,
      name: forecastName,
      clientname: engagement.clientName,
      description: forecastDescription,
      data_type: dataTypefield,
      forecast_percentage: percentageValue,
      startYear: parseFloat(startYear),
      endYear: parseFloat(endYear),
      createddate: forecastData?.createddate ?? new Date(),
      createdby: forecastData?.createdby ?? user.username,
      forecastEndYear: engagement?.foreCastEndYear,
      id: forecastData?.batchGroupID ?? 0,
      dropDownMetaData: [],
    };

    // Emission Data
    
    const selectedScope = (emissionModalData?.scope || [])?.map((x) => {
      return { columnType: "Scope", columnValue: x };
    });
    const selectedCatLevel1 = emissionModalData?.category_level1?.map((x) => {
      return { columnType: "Category_level1", columnValue: x };
    });
    const selectedCatLevel2 = emissionModalData?.category_level2?.map((x) => {
      return { columnType: "Category_level2", columnValue: x };
    });
    const selectedCatLevel3 = emissionModalData?.category_level3?.map((x) => {
      return { columnType: "Category_level3", columnValue: x };
    });

    //Geo Data
    const selectedRegionLevel1 = geoSpecModalData?.region_level1?.map((x) => {
      return { columnType: "Region_level1", columnValue: x };
    });
    const selectedRegionLevel2 = geoSpecModalData?.region_level2?.map((x) => {
      return { columnType: "Region_level2", columnValue: x };
    });
    const selectedRegionLevel3 = geoSpecModalData?.region_level3?.map((x) => {
      return { columnType: "Region_level3", columnValue: x };
    });

    //Org Data
    const selectedEntityLevel1 = orgSpecModalData?.entity_level1?.map((x) => {
      return { columnType: "Entity_level1", columnValue: x };
    });
    const selectedEntityLevel2 = orgSpecModalData?.entity_level2?.map((x) => {
      return { columnType: "Entity_level2", columnValue: x };
    });
    const selectedEntityLevel3 = orgSpecModalData?.entity_level3?.map((x) => {
      return { columnType: "Entity_level3", columnValue: x };
    });
    const selectedEntityLevel4 = orgSpecModalData?.entity_level4?.map((x) => {
      return { columnType: "Entity_level4", columnValue: x };
    });

    //Custom Data
    let selectedCustom1,
      selectedCustom2,
      selectedCustom3 = [];
    if (
      customModalData.custom_specification1 &&
      !customModalData.custom_specification1.includes("N/A")
    ) {
      selectedCustom1 = customModalData?.custom_specification1?.map((x) => {
        return { columnType: "Custom_specification1", columnValue: x };
      });
      selectedCustom2 = customModalData?.custom_specification2?.map((x) => {
        return { columnType: "Custom_specification2", columnValue: x };
      });
      selectedCustom3 = customModalData?.custom_specification3?.map((x) => {
        return { columnType: "Custom_specification3", columnValue: x };
      });
    } else {
      selectedCustom1 = [
        { columnType: "Custom_specification1", columnValue: "All" },
      ];
      selectedCustom2 = [
        { columnType: "Custom_specification2", columnValue: "All" },
      ];
      selectedCustom3 = [
        { columnType: "Custom_specification3", columnValue: "All" },
      ];
    }

    selectedCustom3 = selectedCustom3 ? selectedCustom3 : [{
        "columnType": "Custom_specification3",
        "columnValue": "All"
    }];
    selectedCustom2 = selectedCustom2 ? selectedCustom2 : [{
        "columnType": "Custom_specification2",
        "columnValue": "All"
    }];
    selectedCustom1 = selectedCustom1 ? selectedCustom1 : [{
        "columnType": "Custom_specification1",
        "columnValue": "All"
    }];

    payload.dropDownMetaData = [
      ...selectedScope,
      ...selectedCatLevel1,
      ...selectedCatLevel2,
      ...selectedCatLevel3,
      ...selectedRegionLevel1,
      ...selectedRegionLevel2,
      ...selectedRegionLevel3,
      ...selectedEntityLevel1,
      ...selectedEntityLevel2,
      ...selectedEntityLevel3,
      ...selectedEntityLevel4,
      ...selectedCustom1,
      ...selectedCustom2,
      ...selectedCustom3,
    ];

    try {
      if (forecastData?.id) {
        await updateForecastSpecification({ payload });
      } else {
        const response = await saveForecastSpecification({ payload });
        if(response && response.data) {
          isSubmit = true;
        }
      }
    } catch (e) {
      isSubmit = false;
      console.error(e);
    }

    setIsDataSaveInProgress(false);
    setIsDisableSave(false);
    if(isSubmit){
      navigate(`/${routes.createNewEngagement}/${routes.addforecast}`, {
        state: {
          engagementId: engagement.id,
        },
        gestureEnabled: false,
      });
    }
  }

  async function GetAllHierarchyData() {
    const request = {
      engagement: engagement.engagementCode,
      clientName: engagement.clientName,
    };

    const data = await getHierarchyLevelData({ request });
    dispatch(setHierarchialData({ hierarchialData: data }));
    setHierarchyData(data);
  }

  function handleDatatypeChange(event) {
    setDatatype(event);
    setDataTypeError("");
  }

  const handleFilterModalConfirm = (data) => {
    setEmissionModalData(data?.emissionData);
    setGeoSpecModalData(data?.regionalData);
    setOrgSpecModalData(data?.organisationalData);
    setCustomModalData(data?.customSpecificationData);
  }

   useEffect(() => {
    if (engagement?.id) {
      GetAllHierarchyData();
    }
  }, [engagement?.id]);

  useEffect(() => {
    if (engagement?.id && state?.batchGroupId) {
      setDropdownLoader(true);
      setIsDisableSave(true);
      getForecastDataByGroupId(engagement?.id, state?.batchGroupId);
    }
  }, [engagement?.id, hierarchialData]);

  async function getForecastDataByGroupId(engId, groupId) {
    setDropdownLoader(true);
    setIsDisableSave(true);
    const request = {
      engagementId: engId,
      batchGroupId: groupId,
    };
    const data = await getForecastByGroupId({
      request,
    });
    setForecastData(data.data[data.data.length - 1]);
    setForecastName(data.data[data.data.length - 1].name);
    setForecastDescription(data.data[data.data.length - 1].description);
    setDatatype(data.data[data.data.length - 1].data_type);
    setPercentage(data.data[data.data.length - 1].forecast_percentage);
    setStartYear(data.data[data.data.length - 1].startYear);
    setEndYear(data.data[data.data.length - 1].endYear);

    let scopeArray = [...new Set(data.data.map((element) => element.scope))];
    // setScopeArray(scopeArray);

    let category_level1 = [
      ...new Set(data.data.map((element) => element.category_level1)),
    ];
    let category_level2 = [
      ...new Set(data.data.map((element) => element.category_level2)),
    ];
    let category_level3 = [
      ...new Set(data.data.map((element) => element.category_level3)),
    ];

    let allFilters = {};

    if (state.isValidated === "N") {
      allFilters['scope'] = [];
      allFilters['category_level1'] = [];
      allFilters['category_level2'] = [];
      allFilters['category_level3'] = [];
    } else {
      allFilters['scope'] = scopeArray;
      allFilters['category_level1'] = category_level1;
      allFilters['category_level2'] = category_level2;
      allFilters['category_level3'] = category_level3;
    }

    let entity_level1 = [
      ...new Set(data.data.map((element) => element.entity_level1)),
    ];
    let entity_level2 = [
      ...new Set(data.data.map((element) => element.entity_level2)),
    ];
    let entity_level3 = [
      ...new Set(data.data.map((element) => element.entity_level3)),
    ];
    let entity_level4 = [
      ...new Set(data.data.map((element) => element.entity_asset)),
    ];

    if (state.isValidated === "N") {
      allFilters['entity_level1'] = [];
      allFilters['entity_level2'] = [];
      allFilters['entity_level3'] = [];
      allFilters['entity_level4'] = [];
    } else {
      allFilters['entity_level1'] = entity_level1;
      allFilters['entity_level2'] = entity_level2;
      allFilters['entity_level3'] = entity_level3;
      allFilters['entity_level4'] = entity_level4;
    }

    let region_level1 = [
      ...new Set(data.data.map((element) => element.region_level1)),
    ];
    let region_level2 = [
      ...new Set(data.data.map((element) => element.region_level2)),
    ];
    let region_level3 = [
      ...new Set(data.data.map((element) => element.region_level3)),
    ];

    if (state.isValidated === "N") {
      allFilters['region_level1'] = [];
      allFilters['region_level2'] = [];
      allFilters['region_level3'] = [];
    } else {
      allFilters['region_level1'] = region_level1;
      allFilters['region_level2'] = region_level2;
      allFilters['region_level3'] = region_level3;
    }

    let custom_specification1 = [
      ...new Set(data.data.map((element) => element.custom_specification1)),
    ];
    let custom_specification2 = [
      ...new Set(data.data.map((element) => element.custom_specification2)),
    ];
    let custom_specification3 = [
      ...new Set(data.data.map((element) => element.custom_specification3)),
    ];
    if (state.isValidated === "N") {
      allFilters['custom_specification1'] = [];
      allFilters['custom_specification2'] = [];
      allFilters['custom_specification3'] = [];
    } else {
      allFilters['custom_specification1'] = custom_specification1;
      allFilters['custom_specification2'] = custom_specification2;
      allFilters['custom_specification3'] = custom_specification3;
    }

    // Emmission Records
    console.log('hierarchialData', hierarchialData);
    if(hierarchialData?.length > 0) {
      const uniqueRecords = await processEmissionData(allFilters, hierarchialData, allFilters);
      const allRecords = await handleAllpayload('Emission', allFilters, allFilters, hierarchialData);
      const newRecords = {
          records: uniqueRecords,
          scope: allFilters?.scope,
          category_level1: allFilters?.category_level1,
          category_level2: allFilters?.category_level2,
          category_level3: allFilters?.category_level3,
          allPayload: allRecords?.length > 0 ? allRecords : uniqueRecords,
          selectAll: '',
          functionality: "Edit",
      };

      // Organisational Records
      const uniqueOrgRecords = await processOrgData(allFilters, hierarchialData, allFilters);
      const allOrgRecords = await handleAllpayload('Organisational', allFilters, allFilters, hierarchialData);
      const newOrgRecords = {
          records: uniqueOrgRecords,
          entity_level1: allFilters?.entity_level1,
          entity_level2: allFilters?.entity_level2,
          entity_level3: allFilters?.entity_level3,
          entity_level4: allFilters?.entity_level4,
          allPayload: allOrgRecords?.length > 0 ? allOrgRecords : uniqueOrgRecords,
          selectAll: '',
          functionality: "Edit",
      };

      // Regional Records
      const uniqueRegionRecords = await processRegionData(allFilters, hierarchialData, allFilters);
      const allRegionRecords = await handleAllpayload('Regional', allFilters, allFilters, hierarchialData);
      const newRegionRecords = {
          records: uniqueRegionRecords,
          region_level1: allFilters?.region_level1,
          region_level2: allFilters?.region_level2,
          region_level3: allFilters?.region_level3,
          allPayload: allRegionRecords?.length > 0 ? allRegionRecords : uniqueRegionRecords,
          selectAll: '',
          functionality: "Edit",
      };

      // Custom Specification Records
      const uniqueCustomRecords = await processCustomData(allFilters, hierarchialData, allFilters);
      const allCustomRecords = await handleAllpayload('Custom', allFilters, allFilters, hierarchialData);
      const newCustomRecords = {
          records: uniqueCustomRecords,
          custom_specification1: allFilters?.custom_specification1,
          custom_specification2: allFilters?.custom_specification2,
          custom_specification3: allFilters?.custom_specification3,
          allPayload: allCustomRecords?.length > 0 ? allCustomRecords : uniqueCustomRecords,
          selectAll: '',
          functionality: "Edit",
      };

      console.log('newRecords', {
          emissionData: newRecords,
          organisationalData: newOrgRecords,
          regionalData: newRegionRecords,
          customSpecificationData: newCustomRecords
      });
      setEmissionModalData(newRecords);
      setGeoSpecModalData(newRegionRecords);
      setOrgSpecModalData(newOrgRecords);
      setCustomModalData(newCustomRecords);
    }
    dispatch(setselectedUIAllFilters({selectedUIAllFilters: allFilters}));

    setTimeout(() => {
      setDropdownLoader(false);
    }, 2000);
  }

  async function checkForecastName(value) {
    if (!value || lastCheckedForecastName.current === value) return;
    if(forecastNameRegExp.test(value) && value) {
      lastCheckedForecastName.current = value;
      const request = {
        name: encodeURIComponent(value),
        type: "Forecast",
        engagementId: engagement.id,
      };
      const data = await checkName({ request });
      if (data.code === 1) {
        setForecastErrorName(data.status);
      } else {
        setForecastErrorName("");
      }
    }  
  }

  const handleForecastNameChange = (event) => {
    dispatch(setWafErrorFlag(false));
    let error = "";
    if (event.target.value?.length >= maxLength100) {
      error = addForecastNameRequiredMaxLength;
      setForecastErrorName(error);
      return;
    } else {
      error = "";
      setForecastErrorName(error);
    } 
    setForecastName(event.target.value);
    if (
        forecastNameRegExp.test(event.target.value) &&
        event.target.value !== "-"
      ) {
        if (event.target.value === "") {
          error = addForecastSpecificationForecastNameRequired;
          lastCheckedForecastName.current = "";
        }
        setForecastErrorName(error);
      } else {
        error = commonError;
        setForecastErrorName(error);
      }
  };

  const handleForecastDescriptionChange = (event) => {
    dispatch(setWafErrorFlag(false));
    let error = "";
    // Always update the value to allow typing/pasting
    setForecastDescription(event.target.value);
    // Check validations
    if (event.target.value?.length >= maxLength2000) {
      // Length exceeds 2000 characters
      error = addForecastDescMaxLength;
    } else if (!forecastDescRegExp.test(event.target.value) || event.target.value === "-") {
      // Invalid characters
      error = commonError;
    }
    setForecastErrorDesc(error);
  }

  useEffect(
    () => () => {
      setIsDataSaveInProgress(false);
      setForecastName("");
      setForecastDescription("");
      setPercentage("");
      setStartYear("");
      setEndYear("");
      setDatatype("");
      setEmissionModalData([]);
      setGeoSpecModalData([]);
      setOrgSpecModalData([]);
      setCustomModalData([]);
      setForecastData({});
      setForecastErrorName("");
      setForecastErrorDesc("");
      setForecastErrorPercent("");
      setForecastErrorStartYear("");
      setForecastErrorEndYear("");
      setDataTypeError("");
      setForecastErrorDataSelectionModal("");
    },
    []
  );

  return (
    <div className="add-forecast-specification">
      <div className="add-forecast-specification-eng-header">
        <div className="add-forecast-specification-eng-header-title">
          {steps[currentStep]?.stepHeading}
        </div>
        <div className="add-forecast-specification-eng-header-stepper">
          <Stepper
            steps={steps}
            currentStep={currentStep}
            stepIndex={stepIndex}
          />
        </div>
      </div>
      <div className="add-forecast-content">
        <div className="add-forecast-specification-header ">
          <span className="add-forecast-specification-header-main">
            {addForecastSpecificationHeader}
          </span>
        </div>
        <div className="add-forecast-specification-body">
          <div className="add-forecast-specification-content-body-row">
            <span className="add-forecast-specification-content-body-name-title decarb-input-error-label">
              {addForecastSpecificationForecastName}
              <span className="required-star">*</span>
              <Tooltip
                trigger={<EmissionIcon />}
                variant="ghost"
                tooltipText={forecastNameTooltip}
              ></Tooltip>
            </span>
            <Input
              type={"text"}
              value={forecastName}
              onChange={handleForecastNameChange}
              onBlur={(event) => {
                checkForecastName(event.target.value);
              }}
              errorMessage={forecastErrorName}
              isError={forecastErrorName !== ""}
              disableErrorPlaceholder={false}
              disabled={isDataSaveInProgress || forecastData?.id}
            ></Input>
          </div>
          <div className="add-forecast-specification-content-body-row">
            <span className="add-forecast-specification-content-body-desc-title">
              {addForecastSpecificationForecastDesc}
              <Tooltip
                trigger={<EmissionIcon />}
                variant="default"
                tooltipText={forecastDescriptionTooltip}
              ></Tooltip>
            </span>
            <div style={{ flex: 1 }}>
              <TextArea
                value={forecastDescription}
                onChange={handleForecastDescriptionChange}
                disableErrorPlaceholder={false}
                disabled={isDataSaveInProgress}
                errorMessage={forecastErrorDesc}
                isError={forecastErrorDesc !== ""}
              />
            </div>
          </div>
          <div className="add-forecast-specification-content-body-row">
            <span className="add-forecast-specification-content-body-name-title decarb-input-error-label">
              {addForecastSpecificationDataType}
              <span className="required-star">*</span>
              <Tooltip
                trigger={<EmissionIcon />}
                variant="default"
                tooltipText={forecastDataTypeTooltip}
      ></Tooltip>
            </span>
            <Select
              value={dataTypefield}
              options={addForecastSpecificationDataTypeOptions}
              onChange={handleDatatypeChange}
              errorMessage={dataTypeError}
              isError={dataTypeError !== ""}
              disableErrorPlaceholder={false}
              disabled={isDataSaveInProgress}
            ></Select>
            <span className="add-forecast-specification-content-body-name-title decarb-input-error-label">
      {addForecastSpecificationPercentValue}
              <span className="required-star">*</span>
              <Tooltip
                trigger={<EmissionIcon />}
                variant="default"
                tooltipText={forecastPercentageTooltip}
              ></Tooltip>
            </span>
            <Input
              type="decimal"
              maxLength={percentageValue?.includes("-") ? 6 : 5}
              value={percentageValue}
              allowNegative
              onChange={(event) => {
                setPercentage(event.target.value);
                setForecastErrorPercent("");

                if (!event.target.value) {
                  setForecastErrorPercent(
                    addForecastSpecificationPercentValueRequired
                  );
                }

                if (
                  event.target.value &&
                  (!decimalNumberRegExp.test(event.target.value) ||
                    event.target.value > 100 ||
                    event.target.value < -100)
                ) {
                  setForecastErrorPercent(targetPercentageError);
                }
              }}
              errorMessage={forecastErrorPercent}
              isError={forecastErrorPercent !== ""}
              disableErrorPlaceholder={false}
              disabled={isDataSaveInProgress}
            ></Input>
          </div>
          <div className="add-forecast-specification-content-body-row">
            <span className="add-forecast-specification-content-body-name-title decarb-input-error-label">
              {addForecastSpecificationStartYear}
              <span className="required-star">*</span>
              <Tooltip
                trigger={<EmissionIcon />}
                variant="default"
                tooltipText={forecastStartYearTooltip}
              ></Tooltip>
            </span>
            <Input
              type="number"
              maxLength={4}
              value={startYear}
              onChange={(event) => {
                let year = event.target.value;
                setStartYear(year);
                setForecastErrorStartYear("");

                if (!year) {
                  setForecastErrorStartYear(
                    addForecastSpecificationStartYearRequired
                  );
                }

                if (year && parseFloat(year) <= engagement.mostRecentYear) {
                  setForecastErrorStartYear(
                    addForecastSpecificationStartYearGreaterThanMRY
                  );
                }

                if (year && parseFloat(year) > engagement?.foreCastEndYear) {
                  setForecastErrorStartYear(
                    addForecastSpecificationStartYearLessThanFEY
                  );
                }

                if (
                  year &&
                  endYear &&
                  parseFloat(year) > parseFloat(endYear)
                ) {
                  setForecastErrorStartYear(
                    addForecastSpecificationStartYearGreaterThanEndYear
                  );
                }
              }}
              errorMessage={forecastErrorStartYear}
              isError={forecastErrorStartYear !== ""}
              disableErrorPlaceholder={false}
              disabled={isDataSaveInProgress}
            ></Input>
            <span className="add-forecast-specification-content-body-name-title decarb-input-error-label">
              {addForecastSpecificationEndYear}
              <span className="required-star">*</span>
              <Tooltip
                trigger={<EmissionIcon />}
                variant="default"
                tooltipText={forecastEndYeartooltip}
              ></Tooltip>
            </span>
            <Input
              type="number"
              maxLength={4}
              value={endYear}
              onChange={(event) => {
                let year = event.target.value;

                setEndYear(event.target.value);
                setForecastErrorEndYear("");

                if (!year) {
                  setForecastErrorEndYear(
                    addForecastSpecificationEndYearRequired
                  );
                }

                if (year && parseFloat(year) < engagement.mostRecentYear) {
                  setForecastErrorEndYear(
                    addForecastSpecificationEndYearGreaterThanMRY
                  );
                }

                if (year && parseFloat(year) > engagement?.foreCastEndYear) {
                  setForecastErrorEndYear(
                    addForecastSpecificationEndYearLessThanFEY
                  );
                }

                if (
                  year &&
                  startYear &&
                  parseFloat(year) < parseFloat(startYear)
                ) {
                  setForecastErrorEndYear(
                    addForecastSpecificationEndYearLessThanStartYear
                  );
                }
              }}
              errorMessage={forecastErrorEndYear}
              isError={forecastErrorEndYear !== ""}
              disableErrorPlaceholder={false}
              disabled={isDataSaveInProgress}
            ></Input>
          </div>
          <div class="motif-row">
            <div class="motif-col-xs-2 data-selection-label-forecast">
              <LoadingIndicatorEmbed show={dropdownloader}>
                <Button
                  variant="primary-alt"
                  onClick={() => {
                    setOpenHierarchyModal(true);
                  }}
                  className="add-gmp-params-data-selection-btn-forecast decarb-forecast-dataselection"
                  disabled={isDataSaveInProgress || (state?.batchGroupId && dropdownloader)}
                >
                  <AreaSeacrhIcon />
                  {DataSelection} <span className="required-star">*</span>
                </Button>
              </LoadingIndicatorEmbed>
              {forecastErrorDataSelectionModal ? (
                <MotifErrorMessage className="decarb-input-error-message decarb-data-selection-forecast-error-message">
                  {addForecastSpecificationDataSelectionRequired}
                </MotifErrorMessage>
              ) : (
                <div className="decarb-input-hide-error">No Error</div>
              )}
            </div>
          </div>
          {wafErrorFlag && <div className="waf-error-message">
            {wafErrorMessageState}
          </div>} 
        </div>
      </div>       
      <div className="add-forecast-specification-footer">
        <Button
          variant="secondary"
          onClick={handleCancelClick}
          disabled={isDataSaveInProgress}
        >
          {CancelBtn}
        </Button>
        <div className="new-engagement-footer-nav-buttons">
          <LoadingIndicatorEmbed show={isDataSaveInProgress}>
            <Button
              variant="primary"
              onClick={applyChanges}
              disabled={checkIsDisabled() || wafErrorFlag}
            >
              {SaveBtn}
            </Button>
          </LoadingIndicatorEmbed>
        </div>
      </div>
      <M2FilterModal
        isFilterOpen={openHierarchyModal}
        onClose={() => setOpenHierarchyModal(false)}
        onConfirm={handleFilterModalConfirm}
      />
    </div>
  );
}
